import { Suspense, lazy, useContext, useState } from "react";
import { MenuContext } from "src/contexts/menu-context/MenuContext";
import TrackingCard from "src/components/ui/TrackingCard";
import { LoadingScreen } from "src/components/ui";
import { Grid, Stack, useTheme } from "@mui/material";
import TrackingTextField from "./TrackingTextField";

const TrackingTracingSection = ({ menu }) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState();
  const handleClose = () => setAnchorEl(null);
  const [trackingValue, setTrackingValue] = useState("");
  const { addToNewTab, setTab } = useContext(MenuContext);

  const handleIconClick = (iconItem) => {
    if (iconItem.content) {
      addToNewTab(iconItem);
      setTab(iconItem?.id);
    }
  };

  let Icon;

  const REGEX = /^AVC-(?:1[0-9]|[2-9][0-9])-(?:Fi|Oa|Im|Aq|Ha|Pr|Oi)(?:-\d{4}){6}$/;
  const isValid = REGEX.test(trackingValue);

  return (
    <>
      <Stack>
        <Stack alignItems="right" mt={3} spacing={1}>
          <TrackingTextField setTrackingValue={setTrackingValue} />
        </Stack>
        {isValid && (
          <Grid container justifyContent="center" spacing={1} mt={2}>
            {menu?.menu[0]?.node?.subMenus?.edges?.map((val, index) => (
              <Grid
                key={val?.node?.id}
                item
                xs={3.8}
                onClick={() => {
                  handleIconClick({
                    val: val?.node?.name,
                    id: val?.node?.id,
                    loading: false,
                    content: val?.node?.codeInWeb ? lazy(() => import("src/features/" + val?.node?.codeInWeb)) : null,
                    props: {
                      subMenuID: val?.node?.id,
                      educationalGuidance: val?.node?.educationalGuidance,
                      trackingCode: trackingValue,
                    },
                  });
                  handleClose();
                }}
              >
                <Suspense fallback={<LoadingScreen open={true} title="لطفا منتظر بمانید ..." />}>
                  {(Icon = lazy(() => import("src/components/ui/svgIcon/" + val?.node?.icon)))}
                  <TrackingCard name={val?.node?.name} icon={<Icon fontSize="small" />} />
                </Suspense>
              </Grid>
            ))}
          </Grid>
        )}
      </Stack>
    </>
  );
};

export default TrackingTracingSection;
